import { ChevronDownIcon } from "@heroicons/react/24/outline";
import Loader from "./Loader/loader";
import { FEATURE_FLAG_MULTIPLE_FEEDS } from "../config/feature_flags";

import { Link } from "react-router-dom";

interface HeaderProps {
    handleShow: () => void;
    aboutModalOpen: boolean;
    feedName: string;
    loading: boolean;
}

const Header = ({
  aboutModalOpen,
  feedName,
  handleShow, 
  loading,
}: HeaderProps) => {
  return (
    <header
      className="pt-8 lg:pt-16 px-4max-md:h-screen"
      // removedClassNames="max-md:snap-always max-md:snap-start"
    >
      <div className="w-full text-6xl font-bold text-gray-900 dark:text-white mb-4 lg:text-8xl">
        <h1
          style={{
            fontFamily: "Archivo Black",
            letterSpacing: "3px",
          }}
        >
          Lrner Curiosity Feed
        </h1>
      </div>
      <div className="w-full text-2xl font-bold text-gray-900 dark:text-white mb-12 lg:text-6xl">
        <h2
          style={{
            fontFamily: "Montserrat",
          }}
        >
          Feed Your Wonder
        </h2>
      </div>
      <dialog
        id="my_modal_1"
        className={aboutModalOpen ? "modal-open modal" : "modal"}
      >
        <div className="modal-box">
          <h3 className="font-bold text-lg">About</h3>
          <p className="py-4">
            I like to browse internet feeds, but I'm tired of the outrage. I
            want to be inspired, and to learn something new To be able to dig
            deep when I find something interesting.
          </p>
          <p className="py-4">
            lrner.io is a set of feeds, initially, from art museums public
            datasets, later from astronomical images, journal articles and data
            visualizations showing trends important to our world, like economics
            climate change and the spread of pandemics. These feeds will be
            backed by a curated database, so that if you find a piece of art you
            like you can learn more about the artist, or see their other work,
            contextualized in a timeline or on a map.
          </p>
          <p className="py-4">
            Help me grow this into something that you'll find wonderful. Reach
            out to me on{" "}
            <a
              className="underline hover:text-orange-500"
              href="https://mastodon.social/@mikkergp"
            >
              mastodon
            </a>{" "}
            or on{" "}
            <a
              className="underline hover:text-orange-500"
              href="https://www.threads.net/@lrner.io"
            >
              threads
            </a>
            .
          </p>
          <div className="modal-action">
            <form method="dialog" className="modal-backdrop">
              <button className="btn" onClick={handleShow}>
                Close
              </button>
            </form>
          </div>
        </div>
      </dialog>

      <div className="w-full text-3xl font-bold text-gray-900 dark:text-white mb-12 text-center">
        {loading ? (
          <Loader />
        ) : (
          <h2
            style={{
              fontFamily: "Archivo Black",
            }}
          >
            Scroll Down
            <ChevronDownIcon className="animate-bounce mx-auto text-9xl h-6 w-6 dark:text-white" />
          </h2>
        )}
        {FEATURE_FLAG_MULTIPLE_FEEDS ? (
          <div className="flex">
            <Link
              to="/feeds/art"
              className={
                "btn w-2/4" +
                (feedName === "art" || feedName === undefined
                  ? " btn-accent"
                  : "")
              }
            >
              Art
            </Link>
            <Link
              to="/feeds/astronomy"
              className={
                "btn w-2/4" + (feedName === "astronomy" ? " btn-accent" : "")
              }
            >
              Astronomy
            </Link>
          </div>
        ) : (
          <div></div>
        )}
      </div>
    </header>
  );
};

export default Header